<template>
  <div class="sidebar-section">
    <slot />
  </div>
</template>
